<template>
  <div id="popup-wrap">
    <van-popup v-model="isContact" class="popup-wrap">
      <div class="con-wrap">
        <div class="padding-10-15 contact-header">
          <div class="contact-title padding-b-15">联系电话</div>
          <div class="padding-b-12 font-14">电话：{{serverList.server_mobile}}</div>
          <div class="padding-b-12 font-14">工作时间：09:00-18:00 周一至周五</div>
        </div>
        <div class="contact-img">
          <div>
            <img style="width: 150px" :src="serverList.wechat_code" alt="">
          </div>
          <div class="padding-t-15">微信二维码</div>
        </div>
      </div>
    </van-popup>
    <div class="close-wrap" v-if="isContact">
      <img class="close-img" @click="closePopup" src="../../../../assets/img/h5/pop_close.png" alt="">
    </div>
  </div>
</template>
<script>
  import {
    getServerConfig
  } from '@/api/user'
  export default {
    name: "GetLinked",
    data: function() {
      return {
        isContact: false,
        serverList: {
          wechat_code: '',
          server_mobile: ''
        },
        loading: true
      }
    },
    methods: {
      init: function(isContact) {
        this.loading = true
        this.isContact = isContact
        this.getServerConfig()
      },
      getServerConfig() {
        var that = this
        this.loading = true
        getServerConfig().then(response => {
          that.loading = false
          that.serverList.wechat_code = response.data.wechat_code
          that.serverList.server_mobile = response.data.server_mobile;
        }).catch(error => {
          that.loading = false
          console.log(error)
          that.$Message.error('加载客服信息失败,请稍后再试!')
        })
      },
      closePopup() {
        this.isContact = false;
      }
    }
  }
</script>

<style lang="less" scoped>
  .popup-wrap {
    width: calc(100% - 60px);
    //height: calc(100% - 270px);
    max-height: 70%;
    border-radius: 8px;
    margin-top: -25px;

    .popup-title {
      font-family: Alibaba-PuHuiTi-M;
      font-size: 18px;
      color: #222222;
      text-align: center;
      padding: 5px 0 25px 0;
    }

    .con-wrap {
      // box-shadow: 0 0 6px 2px rgba(0,0,0,0.06);
      border-radius: 4px;
      color: #222222;
      font-size: 13px;
      font-family: Alibaba-PuHuiTi-R;
      font-weight: normal;

      .contact-header {
        background: #FAF9F7;

        .contact-title {
          font-family: Alibaba-PuHuiTi-M;
          font-size: 16px;
        }
      }

      .contact-img {
        background: #FFFFFF;
        font-family: Alibaba-PuHuiTi-M;
        padding: 40px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 16px;
      }
    }
  }

  /deep/.close-wrap {
    bottom: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/home/modal/Contact.vue